import { useEffect } from "react";
import { useLocation } from "wouter";

export function usePageViews(): void {
  const [location] = useLocation();
  useEffect(() => {
    // Deprecated: pageview tracking disabled unless migrated to typed taxonomy
    void location; // keep hook dependency stable
  }, [location]);
}


